import URLs from '~/enums/URLs';

const publicRoutes = [URLs.Message, URLs.Info, URLs.LinkExpired, URLs.CustomerVerified, URLs.Evnoia, URLs.Intro];

export const checkIsRoutePublic = () => publicRoutes.some((publicRoute) => location?.pathname.includes(publicRoute));
